import { SearchPopularSearches } from "@nosto/nosto-js/client";
import PopularSearch from "../Item/PopularSearch";

export type SearchesProps = {
  searches: SearchPopularSearches;
};

export default function PopularSearches({ searches }: SearchesProps) {
  if (!searches?.hits?.length) {
    return null;
  }

  return (
    <>
      {searches.hits.map((search) => (
        <PopularSearch key={search.query} search={search} />
      ))}
    </>
  );
}
